import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const swiperConfig = {
        direction: "horizontal",
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween: 40,
            }
        }
    };

    new Swiper(".documents-slider", swiperConfig);
});
